import React from 'react'
import "./stylesheets/spinner.css"

function LoadingSpinner() {
  return (
<div className="spinner">
  <div className="spinner__square"></div>
  <div className="spinner__square"></div>
  <div className="spinner__square"></div>
  <div className="spinner__square"></div>
</div>
  )
}

export default LoadingSpinner